export function sumByKey(arr, key) {
  return arr.reduce((sum, item) => {
    // First, check if the key exists in the root object
    if (typeof item[key] === "number") {
      return sum + item[key];
    }
    // Then, check if the key exists in packageData
    if (item.packageData && typeof item.packageData[key] === "number") {
      return sum + item.packageData[key];
    }
    return sum;
  }, 0);
}
